import React, { useState } from 'react';
import { LogIn } from '../ui/icons';
import Input from '../ui/Input';
import Button from '../ui/Button';
import HomestreamLogo from '../ui/HomestreamLogo';

interface LoginProps {
    onLogin: (email: string, password: string) => void | Promise<void>;
    error?: string;
}

export default function Login({ onLogin, error }: LoginProps) {
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [isSubmitting, setIsSubmitting] = useState(false);

    const handleSubmit = async (e: React.FormEvent) => {
        e.preventDefault();
        setIsSubmitting(true);

        try {
            // Simulate a slight delay for better UX
            await new Promise(resolve => setTimeout(resolve, 500));
            await onLogin(email, password);
        } finally {
            setIsSubmitting(false);
        }
    };

    return (
        <div className="login-container">
            <img className="login-stadium-sketch" src="/stadium-sketch.png" alt="" aria-hidden="true" />
            <div className='login-card-container'>
            <div className="login-card">
                <div className="login-header">
                    <HomestreamLogo size="large" variant="light" dropShadow />
                    <h1 className="login-title">Admin Login</h1>
                </div>

                <form onSubmit={handleSubmit} className="login-form">
                    <Input
                        label="Email"
                        type="email"
                        value={email}
                        onChange={setEmail}
                        placeholder="Enter your email"
                        required
                        disabled={isSubmitting}
                    />

                    <Input
                        label="Password"
                        type="password"
                        value={password}
                        onChange={setPassword}
                        placeholder="Enter your password"
                        required
                        disabled={isSubmitting}
                    />

                    {error && (
                        <div className="login-error">
                            <span>⚠️ {error}</span>
                        </div>
                    )}

                    <Button
                        type="submit"
                        variant="outline"
                        loading={isSubmitting}
                        disabled={!email || !password}
                    >
                        <span style={{ display: 'flex', alignItems: 'center', gap: '8px', justifyContent: 'center' }}>
                            <LogIn size={18} />
                            Sign In
                        </span>
                    </Button>
                </form>

                <div className="login-footer">
                    <p>Homestream Admin Dashboard v1.0.0</p>
                </div>
            </div>
             </div>
        </div>
    );
}
